import React, {useEffect, useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import {postEditUsedReferral} from '../../../apis/user/editReferral'
import WizButton from '../../../components/button/WizButton'
import WizImage from '../../../components/image/WizImage'
import {useImage} from '../../../utils/image'
import {getUserDetail} from '../../../apis/user/getUserDetail'

interface IProps {
    className?: string
    status?: {
        id: string
        name: string
        thumbnail: string
    }
    userId: string
    refetch?: any
}

const ChangedUsedReferralCodeModal = ({className, status, userId, refetch}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [userStatus, setUserStatus] = useState({id: '', name: '', thumbnail: ''})
    const [searchUserId, setSearchUserId] = useState('')
    const [searchUserDate, setSearchUserDate] = useState('')

    const {renderThumbnail} = useImage()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    useEffect(() => {
        setUserStatus(status)
    }, [status])

    const onClickSubmit = async () => {
        await postEditUsedReferral({
            id: userId,
            used_referral_code: searchUserDate,
        })
        refetch()
        modalRef.current.close()
    }

    const searchUser = async () => {
        const userData = await getUserDetail(searchUserId)

        if (userData) {
            setUserStatus({id: userData?.data?.id, name: userData?.data?.name, thumbnail: userData?.data?.thumbnail})
            setSearchUserDate(userData?.data?.my_referral_code)
        } else {
            setUserStatus({id: '[No Data]', name: '', thumbnail: ''})
        }
    }

    return (
        <>
            <WizModal title={'Changed Referral Code'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>변경하려는 유저의 아이디를 입력해주세요.</Text>
                <div className={'flex items-center gap-x-[5px] '}>
                    <UnderLineInput value={userStatus?.id} className={'mt-[10px] w-full'} onChanged={setSearchUserId} />
                    <WizButton text={'Search'} size={'small'} type={'primary'} onClick={searchUser} />
                </div>
                <div className={'mt-[50px] border border-line02 p-[10px] rounded-[5px] flex items-center gap-x-[5px]'}>
                    <WizImage
                        className={'w-[40px]'}
                        src={
                            !searchUserDate
                                ? status?.thumbnail || renderThumbnail('')
                                : userStatus?.thumbnail || renderThumbnail('')
                        }
                    />
                    <div>
                        <Text className={'text-ti2'}>
                            {!searchUserDate ? status?.name || '[No Data]' : userStatus?.name || '[No Data]'}
                        </Text>
                        <Text className={'text-body_comm text-font03'}>
                            ({!searchUserDate ? status?.id || '-' : userStatus?.id || '-'})
                        </Text>
                    </div>
                </div>

                <div className={'mt-[20px]'}>
                    {!searchUserDate ? (
                        <Text className={'text-center text-body2 text-font_red'}>
                            이전 유저와 동일한 유저로는 변경할 수 없습니다.
                        </Text>
                    ) : userStatus?.id ? (
                        <Text className={'text-center text-body2'}>
                            위 유저로 사용 중인 레퍼럴 코드를 변경하시겠습니까?
                        </Text>
                    ) : (
                        <Text className={'text-center text-body2 text-font_red'}>해당 유저를 찾을 수 없습니다.</Text>
                    )}
                </div>

                <div className={'mt-[20px]'}>
                    <WizButton
                        text={'Changed'}
                        type={'blue'}
                        className={'w-full'}
                        size={'small'}
                        disabled={!searchUserDate || !userStatus?.id}
                        onClick={onClickSubmit}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(ChangedUsedReferralCodeModal)
